import { WorkspaceSelectionField } from '@carboncopyco/components';
import { CloseOutlineIcon } from '@carboncopyco/icons';
import type { Workspace } from '@carboncopyco/types';
import {
  Button,
  Form,
  InputTextField,
  Spacer,
  TextSubHeader,
} from '@carboncopyco/ui';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';
import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { object, string } from 'yup';

export const descriptionSchema = object({
  description: string().required('Required'),
}).required();

interface PublishTourEditProps {
  onCancel: (event) => void;
  publishTour: (form: Record<string, string>) => any;
  tourName?: string;
  tourDescription: string;
  isFirstRevision: boolean;
  workspace?: Workspace;
  initiateNavigateToTourPageAfterPublish?: () => void;
}

export const PublishTourEdit = ({
  onCancel,
  publishTour,
  tourName,
  tourDescription,
  workspace,
  initiateNavigateToTourPageAfterPublish,
}: PublishTourEditProps) => {
  const initialValues = {
    tourName: tourName || '',
    description: tourDescription,
    workspaceId: workspace?.id || '',
  };
  const { state } = useLocation();
  const [formValues, setFormValues] =
    useState<Record<string, string>>(initialValues);

  const { tourId } = useParams();

  const inFolder = !!state?.folderId;
  const { trackEvent } = useAnalytics();

  return (
    <div className="w-ds-400">
      <Form
        enableReinitialize
        onSubmit={publishTour}
        validationSchema={descriptionSchema}
        initialValues={initialValues}
        onValueChange={setFormValues}
      >
        <>
          <div className="flex items-center gap-2.5">
            <TextSubHeader
              color="text-ds-natural-600"
              label="Done editing?"
            />
            <div
              onClick={onCancel}
              className="cursor-pointer ml-auto"
            >
              <CloseOutlineIcon />
            </div>
          </div>
          <Spacer amount={3} />
          <InputTextField
            name="tourName"
            label="Tour name"
            required
          />
          <InputTextField
            label="Describe your changes"
            name="description"
            multiline
            inputSize="sm"
          />
          {workspace && !inFolder && (
            <>
              <Spacer />
              <WorkspaceSelectionField
                workspaces={[workspace]}
                label="Save in..."
                name="workspaceId"
                width={400}
                disabled
              />
            </>
          )}
          <Spacer amount={4} />
          <div className="w-full flex justify-end gap-2 ">
            <Button
              label="Save & Exit"
              secondary
              onClick={async () => {
                await publishTour(formValues);
                initiateNavigateToTourPageAfterPublish?.();
              }}
            />
            <Button
              label="Save"
              submit
              onClick={() => {
                trackEvent(AnalyticsTrackEventName.TOUR_CLICK_PUBLISH, {
                  location: 'tour_editor_save_modal',
                  tourId,
                });
              }}
            />
          </div>
        </>
      </Form>
    </div>
  );
};
